import * as React from 'react'
import { Copy, SpacedFlex, Title, Wrapper } from './styled'

interface Props {
  title: string
  legalList: React.ReactNode[]
}

const TermsAndConditions: React.FC<Props> = ({ title, legalList }) => {
  return (
    <main>
      <SpacedFlex>
        <Wrapper>
          <Title>{title}</Title>
          <Copy>
            {legalList.map((node, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={`terms-${i}`}>
                <span>{node}</span>
                <br />
                <br />
              </React.Fragment>
            ))}
          </Copy>
        </Wrapper>
      </SpacedFlex>
    </main>
  )
}

export default TermsAndConditions
